import { useContext } from 'react';
import { UserAuthContext } from 'utils/context/userContext';

export function useAuth() {
  return useContext(UserAuthContext);
}
